<template>
  <div class="edelivery">
    <ba-header activeModule="E-Delivery Details"></ba-header>
    <div class="edelivery__content u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">E-Delivery dashboard</h2>
      <div class="edelivery__table">
        <div class="edelivery__filters u-mt4">
          <el-form inline>
            <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" placeholder="Pick a date"></el-date-picker></el-form-item>
            <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" placeholder="Pick a date"></el-date-picker></el-form-item>
            <el-form-item label="E-Delivery Insured" class="line-height-3">
              <el-autocomplete
                custom-item="my-item"
                popper-class="my-autocomplete"
                v-model="fileInsuredName"
                :fetch-suggestions="queryPrimaryInsuredNameSearch"
                placeholder="Enter E-Delivery Insured"

                icon="edit"></el-autocomplete>
            </el-form-item>
            <el-form-item label="Policy Number" class="line-height-3">
              <el-autocomplete
                custom-item="my-item"
                popper-class="my-autocomplete"
                v-model="policyNumber"
                :fetch-suggestions="queryPolicyNumberSearch"
                placeholder="Enter Policy Number"

                icon="edit"></el-autocomplete>
            </el-form-item>

            <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
            <el-checkbox @change="loadPage(1)" v-model="showProcessedOnly" class="u-ml4 u-mt2">Show processed only</el-checkbox>
          </el-form>
        </div>

        <div class="schedule-info">
            <ba-edelivery-schedule-info></ba-edelivery-schedule-info>
        </div>

        <div class="u-mt3">
          <el-button icon="el-icon-check" @click="bcEdeliverables.showDialog=true">Direct BC panel</el-button>

          <el-button @click="confirmationDeleteAndResetDeliverable()" :disabled="!areButtonsEnabled" icon="el-icon-check">Delete in BA and Reset in BC</el-button>
          <el-button @click="dialogReimportVisible = true" icon="el-icon-message">Request E-Deliverables Re-import</el-button>
          <e-delivery-tasks-state :companyId="companyId"></e-delivery-tasks-state>

          <el-table @row-click="rowClick" @expand-change="handleRowExpand" @selection-change="selectionDidChange"
                    v-loading="loading" ref="edeliveryTable" class="u-mt3 edelivery-table" :data="items"
                    :row-class-name="baEdeliverablesTableRowClassName"
                    @sort-change="sortChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column label="Policy Number" width="150">
              <template slot-scope="scope">
                <a :href="getPolicyDataFromRow(scope.row).url" target="_blank" title="Will open in new tab">
                  {{getPolicyDataFromRow(scope.row).policyNumber}}</a>
              </template>
            </el-table-column>
            <el-table-column label="Label" width="190">
              <template slot-scope="scope">
                {{ extractLabelFromMetadata(scope.row.edeliverable_metadata) }}
              </template>
            </el-table-column>
            <el-table-column label="Title">
              <template slot-scope="scope">
                <a :href="extractTitleDataFromMetadata(scope.row.edeliverable_metadata).url"
                   target="_blank" title="Will open in new tab">
                  {{extractTitleDataFromMetadata(scope.row.edeliverable_metadata).title}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="print_date" label="Print Date" width="150" sortable></el-table-column>
            <el-table-column label="Processed" width="180" sortable>
              <template slot-scope="scope">
                {{ scope.row.status_update_timestamp | moment('MM/DD/YYYY hh:mm:ss A') }}
              </template>
            </el-table-column>
            <el-table-column prop="delivery_status" label="Delivery Status" width="150">
              <template slot-scope="scope">
                {{ eDeliveryStatusToHumanString(scope.row.delivery_status) }}
              </template>
            </el-table-column>
            <el-table-column type="expand" >
              <template slot-scope="scope">
                <div>
                  <el-checkbox @change="showLogsClicked(scope.row)" v-model="scope.row.showLogs">Show Logs</el-checkbox>
                </div>
                <div v-if="scope.row.showLogs">
                  <el-button @click="showLogsClicked(scope.row)" icon="el-icon-search">Refresh</el-button>
                  <textarea  rows="5" cols="80">{{ scope.row.logs }}
                  </textarea>
                </div>
                <el-checkbox v-model="scope.row.showRawBCData">Show Raw BC Data on import</el-checkbox>
                <div>
                  <textarea v-if="scope.row.showRawBCData" rows="100" cols="100">{{JSON.stringify(scope.row.edeliverable_metadata, null, 2)}}</textarea>
                </div>
                <div>
                <el-spinner v-if="scope.row.userEvents === null"></el-spinner>
                </div>
                <div v-if="scope.row.userEvents !== null" class="linked-user-events-border"
                     v-for="userEvent in scope.row.userEvents">
                  <p v-if="userEvent.metadata"><b>user:</b> {{userEvent.metadata.bc_contact.name}}</p>
                  <p><b>state:</b> {{userEvent.event_status}}</p>
                  <p v-if="userEvent.metadata"><b>email:</b> {{userEvent.metadata.email}}</p>
                  <p v-if="userEvent.metadata"><b>contact id:</b> {{userEvent.metadata.contact_id}}</p>
                  <div v-if="userEvent.linked_edeliveries">
                    <div class="linked-edeliverables-title">
                      <p><b>deliverables: </b></p>
                    </div>
                    <div class="linked-edeliverables-body">
                      <p v-for="linked_edelivery in userEvent.linked_edeliveries">
                        <a :href="extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).url"
                           target="_blank" title="Will open in new tab">
                          {{extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).title}}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="u-mt4" :layout="paginationLayout"
                         :total="total" :page-size="perPage"
                         @current-change="loadPage">
          </el-pagination>
        </div>

      </div>
      <div class="edelivery__paginator">
      </div>
    </div>
    <el-dialog
            title="Request E-Delivery reimport"
            :visible.sync="dialogReimportVisible"
            width="500px"
            :before-close="undefined">
      <el-form inline>
        <el-form-item label="Reimport From" class="line-height-3"><el-date-picker v-model="reimport.from"></el-date-picker></el-form-item>
        <el-form-item label="Reimport To" class="line-height-3"><el-date-picker  v-model="reimport.to"></el-date-picker></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReimportVisible = false" style="vertical-align: top">Cancel</el-button>
        <div style="border: 1px solid black; border-radius: 4px;padding: 3px; display: inline-block; vertical-align: top">
          <div>
            <el-button type="primary"  @click="requestDeliverablesFullAutomatedReimportDialog()">Full-automated Reimport</el-button>
          </div>
          <div>
            <el-checkbox v-model="reimport.forcedApproval" style="float: left;">Forced Approval</el-checkbox>
          </div>
          <div>
            <el-checkbox v-model="reimport.runBcIndex" :disabled="disableRunBcIndex" style="float: left;">Run BC indexing</el-checkbox>
          </div>
        </div>
        <el-button type="danger" @click="reimportAdvancedConsole.showDialog=true; dialogReimportVisible=false" style="vertical-align: top">Advanced import</el-button>
      </span>

    </el-dialog>

    <el-dialog
            title="Advanced import console"
            :visible.sync="reimportAdvancedConsole.showDialog"
            width="700px"
            height="100%"
            :before-close="undefined">
      <el-form inline>
        <el-form-item label="From" class="line-height-3"><el-date-picker v-model="reimportAdvancedConsole.from"></el-date-picker></el-form-item>
        <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="reimportAdvancedConsole.to"></el-date-picker></el-form-item>
        <div>
          <div style="border: 1px solid black; border-radius: 4px;padding: 3px; display: inline-block; vertical-align: top">
            <div>
              <el-button type="primary" @click="requestDeliverablesRawImportDialog()">Import EDeliverables (Raw)</el-button>
            </div>
            <div>
              <el-checkbox v-model="reimportAdvancedConsole.forcedApproval" style="float: left;">Forced Approval</el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="reimportAdvancedConsole.runBcIndex" :disabled="disableRunBcIndexForReimportAdvancedConsole" style="float: left;">Run BC indexing</el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="reimportAdvancedConsole.sendPendingEdeliveryReport" style="float: left;">Send Pending Report</el-checkbox>
            </div>
          </div>
          <el-button type="primary"  @click="openApprovalsDialog()">Open Approval page</el-button>
                    <div style="border: 1px solid black; border-radius: 4px;padding: 3px; display: inline-block; vertical-align: top">
            <div>
              <el-button type="primary" @click="sendApprovedEdeliveryEvents()">Send Edelivery Mails</el-button>
            </div>
            <div>
              <el-checkbox v-model="reimportAdvancedConsole.useWaitingForApproval" style="float: left;">Process unapproved</el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="reimportAdvancedConsole.sendEdeliveredReport" style="float: left;">Send Report Emails</el-checkbox>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
           <el-button @click="reimportAdvancedConsole.showDialog = false">Close</el-button>

      </span>
    </el-dialog>
    <el-dialog
            title="E-Deliverables: BC state"
            :visible.sync="bcEdeliverables.showDialog"
            width="60%"
            height="100%"
            :before-close="undefined">
      <el-form inline>
        <el-form-item label="From" class="line-height-3"><el-date-picker v-model="bcEdeliverables.from"></el-date-picker></el-form-item>
        <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="bcEdeliverables.to"></el-date-picker></el-form-item>
        <el-checkbox v-model="bcEdeliverables.unprocessedOnly">Only unprocessed</el-checkbox>
        <div>
          <el-button type="info"  @click="downloadEdeliverablesListXls()">Download Xls</el-button>
          <el-button type="primary"  @click="getUnprocessedBcDocsInfo()">Show</el-button>
          <el-button type="primary"  @click="indexBcDocsInRange()">Index</el-button>
          <el-button type="danger" @click="removeBcDocsInRange()" >Remove</el-button>
        </div>
      </el-form>
      <el-table v-loading="bcEdeliverables.loading"
                class="u-mt3 edelivery-table" :data="bcEdeliverables.items"
                :row-class-name="bcEdeliverablesTableRowClassName">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column label="Policy Number" width="150">
              <template slot-scope="scope">
                {{scope.row.meta_data.policy.policy_number}}
              </template>
            </el-table-column>
            <el-table-column label="Label" width="190">
              <template slot-scope="scope">
                {{ extractLabelFromMetadata(scope.row.meta_data) }}
              </template>
            </el-table-column>
            <el-table-column label="Title">
              <template slot-scope="scope">
                {{ extractTitleFromMetadata(scope.row.meta_data) }}
              </template>
            </el-table-column>
            <el-table-column prop="print_date" label="Print Date" width="150"></el-table-column>
            <el-table-column prop="state" label="BC Delivery Status" width="150"></el-table-column>
            <el-table-column prop="exclude_from_printing_queue" label="Exclude from printing queue" width="150">
                            <template slot-scope="scope">
                {{scope.row.exclude_from_printing_queue}}
              </template>
            </el-table-column>
            <el-table-column prop="ba_delivery_status" label="Status">
            </el-table-column>
          </el-table>
      <span slot="footer" class="dialog-footer">
           <el-button @click="bcEdeliverables.showDialog = false">Close</el-button>

      </span>
    </el-dialog>
    <ba-approval-dialog ref="baApprovalDialog"></ba-approval-dialog>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import BaCompanyImage from '@/modules/appearance/company-image.component'
import BaApprovalDialog from '@/components/approval.dialog.component.vue'
import ElButton from 'element-ui/packages/button/src/button'
import EDeliveryTasksState from './e-delivery-tasks-state.component.vue'
import EdeliveryScheduleInfo from '@/components/edelivery.schedule.info.component.vue'

import axios from 'axios'
import config from '@/config'
import _ from 'lodash'
import {humanizeEdeliveryStatus, getEdeliveryRowCssStyleByStatus, convertDateToYYYYMMDD} from '@/shared/misc.utils'

export default {
  components: {
    ElButton,
    BaCompanyImage,
    EDeliveryTasksState,
    BaApprovalDialog,
    'ba-edelivery-schedule-info': EdeliveryScheduleInfo,
  },
  name: 'ba-edelivery-details',
  data () {
    let now = new Date()
    let initialReimportFrom = (new Date()).setDate(now.getDate() - 7)
    let initialReimportTo = (new Date()).setDate(now.getDate() + 1)
    return {
      companyId: this.$route.params.companyId,
      edeliveryUserEvents: {1: 0},
      range: {
        from: '',
        to: '',
      },
      reimport: {
        from: initialReimportFrom,
        to: initialReimportTo,
        forcedApproval: true,
        runBcIndex: true
      },
      bcEdeliverables: {
        from: initialReimportFrom,
        to: initialReimportTo,
        unprocessedOnly: true,
        items: [],
        loading: false,
        showDialog: false
      },
      reimportAdvancedConsole: {
        from: initialReimportFrom,
        to: initialReimportTo,
        forcedApproval: false,
        runBcIndex: true,
        sendPendingEdeliveryReport: false,
        useWaitingForApproval: false,
        sendEdeliveredReport: false,
        showDialog: false,
      },
      items: [],
      loading: true,
      total: 0,
      perPage: 50,
      numPages: 0,
      selectedItems: [],
      showProcessedOnly: true,
      onlyElectronicDelivery: true,
      showRawBCData: false,
      fileInsuredName: '',
      policyNumber: '',
      insuredsPolicyTuples: [],
      showLogs: false,
      dialogGetBcEdeliverables: false,
      dialogReimportVisible: false,
      orderBy: '-status_update_timestamp',
    }
  },
  computed: {
    ...mapGetters('shared', ['companyById']),
    paginationLayout () {
      let moreThan15Pages = this.numPages > 15
      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
    areButtonsEnabled () {
      return !this.loading && this.selectedItems.length > 0
    },
    disableRunBcIndex () {
      // if date difference  > 10 days - disable BC indexing in order to avoid process stuck
      let diffTime = Math.abs(this.reimport.to - this.reimport.from)
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      let outOfRange = diffDays > 14
      if (outOfRange) {
        this.reimport.runBcIndex = false
      }
      return outOfRange
    },
    disableRunBcIndexForReimportAdvancedConsole () {
      // if date difference  > 10 days - disable BC indexing in order to avoid process stuck
      let diffTime = Math.abs(this.reimportAdvancedConsole.to - this.reimportAdvancedConsole.from)
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      let outOfRange = diffDays > 14
      if (outOfRange) {
        this.reimportAdvancedConsole.runBcIndex = false
      }
      return outOfRange
    }
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  methods: {
    eDeliveryStatusToHumanString (status) {
      return humanizeEdeliveryStatus(status)
    },
    sortChange (sortProperties) {
      let column = sortProperties.column
      let columnName = column.label === 'Processed' ? 'status_update_timestamp': 'print_date'
      this.orderBy = column.order === 'descending' ? '-' + columnName : columnName
      this.loadPage(1)
    },
    openApprovalsDialog () {
      this.$refs.baApprovalDialog.showDialog({
        companyId: this.companyId,
        dateFrom: this.reimportAdvancedConsole.from,
        dateTo: this.reimportAdvancedConsole.to,
        adminMode: true,
        readOnlyDates: true,
      })
    },
    getCompany () {
      return this.companyById(this.companyId)
    },
    extractTitleDataFromMetadata (metadata) {
      let company = this.getCompany()
      let title = metadata.file ? metadata.file.title : metadata.form.title
      let edeliverableBcId = metadata.file ? metadata.file.id : metadata.form.id
      return {
        url: company.britecore_url + '/gateway?file=core.uploads&method=getAttachment&id=' + edeliverableBcId,
        title: title
      }
    },
    getPolicyDataFromRow (row) {
      let policyEntity = row.edeliverable_metadata.policy
      return {
        policyNumber: policyEntity.policy_number,
        url: this.getCompany().britecore_url + '/britecore/policies/information?policyId=' + policyEntity.id
      }
    },
    extractTitleFromMetadata (metadata) {
      return metadata.file ? metadata.file.title : metadata.form.title
    },
    extractLabelFromMetadata (metadata) {
      return metadata.file ? metadata.file.label : 'Form'
    },
    downloadEdeliverablesListXls () {
      let url = config.url + '/company/' + this.companyId + '/get_bc_edelivery_objects_xls/?token=' + localStorage.carrierToken +
        '&from_date=' + convertDateToYYYYMMDD(this.bcEdeliverables.from) + '&to_date=' + convertDateToYYYYMMDD(this.bcEdeliverables.to) +
        '&unprocessed_only=' + this.bcEdeliverables.unprocessedOnly
      window.open(url, '_blank')
    },
    getClassByStatus (status) {
      return getEdeliveryRowCssStyleByStatus(status)
    },
    baEdeliverablesTableRowClassName ({row, rowIndex}) {
      let status = row.delivery_status
      return this.getClassByStatus(status)
    },
    bcEdeliverablesTableRowClassName ({row, rowIndex}) {
      let status = row.ba_delivery_status
      return this.getClassByStatus(status)
    },
    showLogsClicked (row) {
      if (row.showLogs === true) {
        row.logs = 'Requesting data...'
        axios.get(`${config.url}/company/${this.companyId}/logs/edelivery/${row.id}/`).then((ret) => {
          let logs = ret.data.data
          let lines = []
          logs.forEach(log => {
            let timestamp = log['timestamp'].substring(0, 19)
            lines.push(timestamp + ': ' + log['line'])
          })
          row.logs = lines.join('\n')
        })
      }
    },
    getFitableTuples () {
    // returns tuples that fits this.policyNumber and this.fileInsuredName filtering
      let fittedTuples = []
      this.insuredsPolicyTuples.forEach(value => {
        let contactName = value[0]
        let policyName = value[1]
        if (this.policyNumber !== '' && !policyName.toLowerCase().includes(this.policyNumber.toLowerCase())) {
          return // continue cycle
        }
        if (this.fileInsuredName !== '' && !contactName.toLowerCase().includes(this.fileInsuredName.toLowerCase())) {
          return // continue cycle
        }
        fittedTuples.push(value)
      })
      return fittedTuples
    },
    extractSortedFieldList (fieldName, tuples) {
      // extracts value from tuple list, sorting and making list with values [{value: value}...]
      let indexToExtract = fieldName === 'policyNumber' ? 1 : 0
      let fitableTuples = tuples
      let policyNumbers = []
      fitableTuples.forEach(value => {
        let policyName = value[indexToExtract]
        if (!policyNumbers.includes(policyName)) {
          policyNumbers.push(policyName)
        }
      })
      policyNumbers.sort()
      let result = []
      policyNumbers.forEach(value => {
        result.push({value: value})
      })
      return result
    },

    queryPolicyNumberSearch (queryString, cb) {
      cb(this.extractSortedFieldList('policyNumber', this.getFitableTuples()))
    },
    queryPrimaryInsuredNameSearch (queryString, cb) {
      cb(this.extractSortedFieldList('contactName', this.getFitableTuples()))
    },
    handleRowExpand (row, expanded) {
      row.userEvents = null
      this.showLogs = false
      axios.get(`${config.url}/company/${this.companyId}/edelivery_object/${row.id}/user_events/`).then((ret) => {
        row.userEvents = ret.data.data
      })
    },
    rowClick (selectedObject) {
      this.$refs.edeliveryTable.toggleRowSelection(selectedObject)
    },
    loadInitial () {
      this.loadPage(1)
    },
    setSelectionStateForAll (desiredCheckedState) {
      if (this.items) {
        this.items.forEach(row => {
          this.$refs.edeliveryTable.toggleRowSelection(row, desiredCheckedState)
        })
      }
    },
    checkAll () {
      this.setSelectionStateForAll(true)
    },
    uncheckAll () {
      this.setSelectionStateForAll(false)
    },
    loadPage (page) {
      console.log('loadPage')
      this.loading = true
      let params = {
        per_page: this.perPage,
        page: page,
        show_processed_only: this.showProcessedOnly,
        edeliverable_contact_name: this.fileInsuredName,
        policy_number: this.policyNumber,
        order_by: this.orderBy,
      }
      if (this.range.from !== '') {
        params.from_date = convertDateToYYYYMMDD(this.range.from)
      }
      if (this.dateTo !== '') {
        params.to_date = convertDateToYYYYMMDD(this.range.to)
      }
      axios.get(`${config.url}/company/${this.companyId}/get_edelivery_objects/`, {params: params})
        .then((ret) => {
          let responseData = ret.data.data
          let items = responseData.search_result.items
          items.forEach(
            (item) => {
              item.userEvents = []
              item.logs = ''
              item.showLogs = false
              item.showRawBCData = false
            }
          )
          this.items = items
          this.total = responseData.search_result.total
          this.perPage = responseData.search_result.page_size
          this.numPages = responseData.search_result.num_pages
          this.insuredsPolicyTuples = responseData.edeliverable_contact_names_policy_numbers_pairs
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectionDidChange (selectedItems) {
      this.selectedItems = selectedItems
    },
    requestDeliverablesFullAutomatedReimport () {
      axios.post(`${config.url}/company/${this.companyId}/request_edelivery_import/`, {
        from_date: convertDateToYYYYMMDD(this.reimport.from),
        to_date: convertDateToYYYYMMDD(this.reimport.to),
        forced_approval: this.reimport.forcedApproval,
        run_bc_indexing: this.reimport.runBcIndex,
        send_approved_edelivery_events: true
      })
        .then(response => {
          this.loadPage(1)
        })
        .catch(error => {
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    requestDeliverablesRawImport () {
      axios.post(`${config.url}/company/${this.companyId}/request_edelivery_import/`, {
        from_date: convertDateToYYYYMMDD(this.reimportAdvancedConsole.from),
        to_date: convertDateToYYYYMMDD(this.reimportAdvancedConsole.to),
        forced_approval: this.reimportAdvancedConsole.forcedApproval,
        run_bc_indexing: this.reimportAdvancedConsole.runBcIndex,
        send_pending_edelivery_report: this.reimportAdvancedConsole.sendPendingEdeliveryReport,
        send_approved_edelivery_events: false
      })
        .then(response => {
          this.loadPage(1)
        })
        .catch(error => {
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    sendApprovedEdeliveryEvents () {
      let dictToSend = {
        use_waiting_for_approval: this.reimportAdvancedConsole.useWaitingForApproval,
        send_edelivered_report: this.reimportAdvancedConsole.sendEdeliveredReport,
      }
      if (this.reimportAdvancedConsole.from !== '') {
        dictToSend.from_date = convertDateToYYYYMMDD(this.reimportAdvancedConsole.from)
      }
      if (this.reimportAdvancedConsole.to !== '') {
        dictToSend.to_date = convertDateToYYYYMMDD(this.reimportAdvancedConsole.to)
      }
      axios.post(`${config.url}/company/${this.companyId}/send_approved_edelivery_events/`, dictToSend)
        .then(response => {
          this.loadPage(1)
        })
        .catch(error => {
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    deleteAndResetDeliverable (selectedItems) {
      let ids = this.idsFromItems(selectedItems)
      this.loading = true
      axios.post(`${config.url}/company/${this.companyId}/delete_and_reset_delivery_object/`, {ids: ids})
        .then(response => {
          let data = response.data.data
          // we need to check is everything deleted. In response we receive BC ids, not BA. Need conversion.
          let undeletedItems = []
          selectedItems.forEach(
            item => {
              if (!data[item.edeliverable_id]) {
                undeletedItems.push(item)
              }
            }
          )
          this.loadPage(1)
          if (undeletedItems.length) {
            this.confirmationForcedDeleteDeliverable(undeletedItems)
          }
        })
        .catch(error => {
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    forceDeleteAndResetDeliverable (undeletedItems) {
      let ids = this.idsFromItems(undeletedItems)
      this.loading = true
      axios.post(`${config.url}/company/${this.companyId}/delete_and_reset_delivery_object/`, {ids: ids, forced: true})
        .then(response => {
          this.loadPage(1)
        })
        .catch(error => {
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    idsFromItems (selectedItems) {
      return _.map(selectedItems, function (item) {
        return item['id']
      })
    },
    getUnprocessedBcDocsInfo () {
      this.bcEdeliverables.loading = true
      axios.post(`${config.url}/company/${this.companyId}/get_bc_edelivery_objects/`, {
        from_date: convertDateToYYYYMMDD(this.bcEdeliverables.from),
        to_date: convertDateToYYYYMMDD(this.bcEdeliverables.to),
        unprocessed_only: this.bcEdeliverables.unprocessedOnly
      })
        .then(response => {
          this.bcEdeliverables.items = response.data.data.search_result
          this.bcEdeliverables.loading = false
        })
        .catch(error => {
          this.bcEdeliverables.loading = false
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    indexBcDocsInRange () {
      this.bcEdeliverables.loading = true
      axios.post(`${config.url}/company/${this.companyId}/index_bc_edelivery_objects/`, {
        from_date: convertDateToYYYYMMDD(this.bcEdeliverables.from),
        to_date: convertDateToYYYYMMDD(this.bcEdeliverables.to),
        unprocessed_only: this.bcEdeliverables.unprocessedOnly
      })
        .then(response => {
          this.bcEdeliverables.loading = false
          this.$alert(response.data.data)
        })
        .catch(error => {
          this.bcEdeliverables.loading = false
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },
    removeBcDocsInRange () {
      this.bcEdeliverables.loading = true
      axios.post(`${config.url}/company/${this.companyId}/remove_bc_edelivery_objects/`, {
        from_date: convertDateToYYYYMMDD(this.bcEdeliverables.from),
        to_date: convertDateToYYYYMMDD(this.bcEdeliverables.to),
        unprocessed_only: this.bcEdeliverables.unprocessedOnly
      })
        .then(response => {
          this.bcEdeliverables.loading = false
          this.$alert(response.data.data)
        })
        .catch(error => {
          this.bcEdeliverables.loading = false
          console.warn(error)
          this.$message({
            type: 'error',
            message: 'Failed to perform action.'
          })
        })
    },

    confirmationDeleteAndResetDeliverable () {
      let entToDelete = []
      this.selectedItems.forEach((item) => {
        entToDelete.push(item.edeliverable_metadata.file ? item.edeliverable_metadata.file.title : item.edeliverable_metadata.form.title)
      })
      this.$confirm(
        `This will delete from BriteApps and reset in BriteCore ${entToDelete} E-Delivery objects. Continue?`,
        'E-Deliveries are about to be reset', {
          confirmButtonText: 'Delete and Reset',
          cancelButtonText: 'Cancel',
          type: 'info'
        }
      )
        .then(() => {
          this.deleteAndResetDeliverable(this.selectedItems)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },
    confirmationForcedDeleteDeliverable (undeletedItems) {
      this.$confirm(
        `Some of records were not deleted in Britecore. Should we remove them from Briteapps?`,
        'E-Deliveries are about to be removed from BA', {
          confirmButtonText: 'Force Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.forceDeleteAndResetDeliverable(undeletedItems)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },
    sendApprovedEdeliveryEventsDialog () {
      this.$confirm(
        `This will send E-Delivery emails for certain term. Continue?`,
        'E-Delivery Events are about to created', {
          confirmButtonText: 'Send Emails',
          cancelButtonText: 'Cancel',
          type: 'info'
        })
        .then(() => {
          this.sendApprovedEdeliveryEvents()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },
    requestDeliverablesRawImportDialog () {
      this.$confirm(
        `This will request E-Delivery objects raw-import for certain term. Continue?`,
        'E-Deliveries are about to imported', {
          confirmButtonText: 'Raw Import',
          cancelButtonText: 'Cancel',
          type: 'info'
        })
        .then(() => {
          this.requestDeliverablesRawImport()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },
    requestDeliverablesFullAutomatedReimportDialog () {
      this.$confirm(
        `This will request E-Delivery objects full-import for certain term. Continue?`,
        'E-Deliveries are about to imported', {
          confirmButtonText: 'Reimport',
          cancelButtonText: 'Cancel',
          type: 'info'
        })
        .then(() => {
          this.dialogReimportVisible = false
          this.requestDeliverablesFullAutomatedReimport()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },

    willRequestDeliverablesReimport () {
      this.$confirm(
        `This will request E-Delivery objects reimport for certain term. Continue?`,
        'E-Deliveries are about to reimported', {
          confirmButtonText: 'Reimport',
          cancelButtonText: 'Cancel',
          type: 'info'
        })
        .then(() => {
          this.dialogReimportVisible = false
          this.requestDeliverablesReimport()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Operation canceled'
          })
        })
    },
  },
}
</script>

<style scoped>
  .line-height-3 {
    line-height: 2em;
  }

</style>

<style>
  .edelivery .el-pager li.active {
    color: #fff;
    background-color: #409EFF;
  }

  .edelivery-table {
    width: 100%;
  }

  .linked-edeliverables-title {
    display: inline-block;
    vertical-align: top
  }
  .linked-edeliverables-body {
    display: inline-block;
  }

  .linked-user-events-border {
    border: 1px solid;
    border-radius:10px;
    padding: 5px
  }
  .schedule-info {
    color: red;
  }

</style>

